module.exports = __webpack_public_path__ + "static/img/publicity-kefu.93f1a29.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-kefu.png
// module id = kJLe
// module chunks = 1